export const ALLOWED_SYMBOLS_ALERT = 'Only lowercase letters, numbers, and hyphens/underscores are allowed.'
export const API_KEYS_LIMIT_ALERT = 'You’ve reached the limit for the number of API keys for this bot.'
export const UNIQUE_NAME_ALERT = 'This name is already used. Create unique API key name.'
export const MAX_LENGTH_ALERT = "You've reached the max length for the API key name — 64 characters"
